'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _semanticUiReact = require('semantic-ui-react');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CampaignOverview = function CampaignOverview(_ref) {
  var overview = _ref.overview,
      documents = _ref.documents;

  var overviewText = { __html: _lodash2.default.get(overview, 'text', '') };
  return _react2.default.createElement(
    _semanticUiReact.Card,
    { fluid: true },
    _react2.default.createElement(
      _semanticUiReact.Card.Content,
      null,
      _react2.default.createElement(
        _semanticUiReact.Card.Header,
        null,
        'Campaign Overview'
      ),
      _react2.default.createElement(
        _semanticUiReact.Card.Description,
        null,
        'overview of the campaign and the results'
      )
    ),
    _react2.default.createElement(
      _semanticUiReact.Card.Content,
      null,
      _react2.default.createElement('p', { dangerouslySetInnerHTML: overviewText }),
      !_lodash2.default.isEmpty(documents) && _lodash2.default.has(_lodash2.default.head(documents), 'filePath') && _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_semanticUiReact.Divider, null),
        _react2.default.createElement(
          _semanticUiReact.Grid,
          { container: true },
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            { columns: _lodash2.default.size(documents) },
            _lodash2.default.map(documents, function (document) {
              return _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                { textAlign: 'center' },
                _react2.default.createElement(
                  'a',
                  { href: 'https://discussions-uploads-production.s3-eu-west-1.amazonaws.com/' + _lodash2.default.get(document, 'filePath') },
                  _react2.default.createElement(_semanticUiReact.Icon, { size: 'huge', name: 'file pdf' }),
                  ' ',
                  _lodash2.default.get(document, 'name')
                )
              );
            })
          )
        )
      )
    )
  );
};

CampaignOverview.propTypes = {
  overview: _propTypes2.default.object.isRequired,
  documents: _propTypes2.default.array
};

CampaignOverview.defaultProps = {
  documents: []
};

exports.default = CampaignOverview;


//////////////////
// WEBPACK FOOTER
// ./node_modules/dyzio-shared-components/lib/reports/tiktok-report/campaign-overview.js
// module id = 2204
// module chunks = 1